// extracted by mini-css-extract-plugin
export default {"waitScreen":"waitScreen-QxmCe","disconnectedScreen":"disconnectedScreen-xGa8B","summaryButtonContainer":"summaryButtonContainer-w02yE"};